import { createContext, useContext, useState } from 'react';
import type { ReactNode } from 'react';

interface AppShellContextValue {
  drawerOpen: boolean;
  openDrawer:  () => void;
  closeDrawer: () => void;
  toggleDrawer: () => void;
}

const AppShellContext = createContext<AppShellContextValue>({
  drawerOpen:   false,
  openDrawer:   () => {},
  closeDrawer:  () => {},
  toggleDrawer: () => {},
});

export function AppShellProvider({ children }: { children: ReactNode }) {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <AppShellContext.Provider value={{
      drawerOpen,
      openDrawer:   () => setDrawerOpen(true),
      closeDrawer:  () => setDrawerOpen(false),
      toggleDrawer: () => setDrawerOpen(v => !v),
    }}>
      {children}
    </AppShellContext.Provider>
  );
}

export function useAppShell(): AppShellContextValue {
  return useContext(AppShellContext);
}
